// ===== Dinheiro =====
// Todo valor em reais passa por aqui antes de virar total, de ir ao banco ou de
// aparecer na tela. Sem dependencia nenhuma de proposito: assim pode ser
// importado por data.jsx, store.jsx, api.js e pelas telas sem esbarrar na regra
// de imports (store.jsx/data.jsx nao podem importar api.js/supabase.js).
//
// POR QUE ESTE ARQUIVO EXISTE (pedido do Kaio, 28/08: "isso nao pode acontecer").
// A formula da proposta -- quantidade * preco * (1 - desconto/100), em
// src/proposta.jsx:446 e src/drawer.jsx:833 -- produz duas coisas ruins:
//   1. fracao de centavo legitima: 1 x 148,50 com 5% = 141,075
//   2. lixo de ponto flutuante: 3 x 148,50 com 5% = 423.22499999999997
// Medido em 28/08: 480 de 800 combinacoes realistas passam de 2 casas.
//
// A ARMADILHA (por isso nao e uma linha so):
// `Math.round(x * 100) / 100` -- a correcao que todo mundo escreve -- COME
// CENTAVO. 141.075 * 100 da 14107.499999999998, entao devolve 141,07 onde o
// certo e 141,08. E `toFixed(2)` erra em outros pontos; a propria MDN documenta:
//   "(2.55).toFixed(1); // '2.5'  -- it rounds down as it can't be represented
//    exactly by a float and the closest representable float is lower"
//   developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toFixed
//
// O que funciona (medido contra os dois acima em tests/unit/dinheiro.test.js):
// deslocar a virgula pelo TEXTO do numero, com `e2`/`e-2`, em vez de multiplicar
// por 100. A multiplicacao introduz erro novo; a notacao exponencial reinterpreta
// o mesmo numero, sem conta no meio.

// Arredonda para centavo, meio centavo se AFASTANDO do zero (o que a pessoa
// espera: 141,075 -> 141,08; -141,075 -> -141,08).
export function dinheiro(valor) {
  const n = typeof valor === 'number' ? valor : Number(valor);
  if (!Number.isFinite(n)) return 0;          // null, undefined, '', NaN, Infinity
  if (n === 0) return 0;

  const sinal = n < 0 ? -1 : 1;
  const abs = Math.abs(n);

  // `${abs}e2` so funciona enquanto o numero NAO estiver em notacao exponencial
  // (o JS so usa expoente abaixo de 1e-7 e acima de 1e21 -- fora de qualquer
  // valor de proposta). Se cair fora, a conversao vira NaN e o fallback assume.
  const deslocado = Number(`${abs}e2`);
  if (!Number.isFinite(deslocado)) return sinal * (Math.round(abs * 100) / 100);

  const emCentavos = Math.round(deslocado);
  const devolta = Number(`${emCentavos}e-2`);
  return Number.isFinite(devolta) ? sinal * devolta : sinal * (emCentavos / 100);
}

// Soma arredondando CADA parcela antes de somar, e o resultado depois.
// Arredondar antes e o que faz o rodape da proposta bater com as linhas
// impressas: somando valores nao arredondados e arredondando so no fim, o
// cliente soma na calculadora dele e da diferente da nossa.
export function somarDinheiro(valores = []) {
  let acc = 0;
  for (const v of valores) acc += dinheiro(v);
  return dinheiro(acc);
}

// Le o que a pessoa DIGITA em reais: "1.500,50" -> 1500.5; "R$ 80.000" -> 80000.
// Virgula e decimal; ponto e milhar. Sem virgula, um ponto seguido de 1 ou 2
// digitos no fim e decimal ("1500.5"), porque ninguem escreve milhar assim.
// Ate 23/09 o campo de meta fazia parseInt so dos digitos: "1.500,50" virava
// 150050 -- os centavos entravam como reais (issue #14 do Kaio).
export function lerDinheiroBR(texto) {
  let s = String(texto ?? '').replace(/R\$/g, '').replace(/\s/g, '');
  if (!s) return 0;
  if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
  else if (!/\.\d{1,2}$/.test(s)) s = s.replace(/\./g, '');
  return dinheiro(Number(s));
}
